import { type ReactNode, Children, isValidElement, cloneElement } from 'react';
import type { ColumnDef } from '@deckspace/types';
import { ListRowProvider } from './ListRowContext';

interface ListViewProps {
  nodeId: string;
  template?: string;
  children?: ReactNode;
  // Injected by withDataset HOC (Task 8):
  rows: Record<string, unknown>[];
  columnDefs?: ColumnDef[];
}

export function ListView({ children, rows }: ListViewProps) {
  return (
    <div className="flex flex-col gap-2">
      {Array.isArray(rows) &&
        rows.map((row, i) => (
          <ListRowProvider key={String(row.id ?? i)} row={row}>
            {Children.map(children, (child) =>
              isValidElement(child) ? cloneElement(child) : child
            )}
          </ListRowProvider>
        ))}
    </div>
  );
}
